// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox__Checkbox__9j+s0"};